import { useEffect, useState } from "react";

const PricingSection = () => {
  const [width, setWidth] = useState(0);

  const getDeviceType = (width) => {
    if (width <= 767) {
      return "Mobile";
    } else if (width >= 768 && width <= 991) {
      return "Tablet";
    } else {
      return "Computer";
    }
  };

  useEffect(() => {
    updateDimensions();
  }, []);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  return (
    <>
      {getDeviceType(width) !== "Mobile" ? (
        <div className="desktop">
          <div
            style={{
              width: "100%",
              height: "100%",
              paddingLeft: getDeviceType(width) === "Mobile" ? 10 : "6.25rem",
              paddingRight: getDeviceType(width) === "Mobile" ? 10 : "6.25rem",
              paddingTop: "2.188rem",
              background: "white",
              overflow: "hidden",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: "3rem",
                fontFamily: "Calibre",
                fontWeight: 700,
                wordWrap: "break-word",
                paddingBottom: "1.5rem",
              }}
            >
              BOAhub PRICING
            </div>
            <div
              style={{
                width: "100%",
                background: "white",
                overflow: "hidden",
                justifyContent: "center",
                alignItems: "flex-start",
                display: "inline-flex",
              }}
            >
              <div
                style={{
                  flex: "1 1 0",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.625rem",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    width: "22.5%",
                    height: "2.25rem",
                    position: "relative",
                  }}
                />
                <div
                  style={{
                    height: "10.75rem",
                    padding: "0.625rem",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                />
              </div>
              <div
                style={{
                  width: "22.5%",
                  height: "13.625rem",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.625rem",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    width: "22.5%",
                    height: "2.25rem",
                    position: "relative",
                  }}
                />
                <div
                  style={{
                    height: "10.75rem",
                    padding: "0.625rem",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    Ecommerce
                  </div>
                  <div
                    style={{
                      color: "var(--BOA-Green, #66cb23)",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    $150 per month
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "22.5%",
                  height: "100%",
                  borderTopLeftRadius: "0.625rem",
                  borderTopRightRadius: "0.625rem",
                  border: "0.25rem #66cb23 solid",
                  borderBottom: "none",
                  outlineOffset: "-0.25rem",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.625rem",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    alignSelf: "stretch",
                    height: "2.25rem",
                    paddingLeft: "2.938rem",
                    paddingRight: "2.938rem",
                    paddingTop: "0.125rem",
                    paddingBottom: "0.125rem",
                    background: "#66cb23",
                    borderTopLeftRadius: "0.25rem",
                    borderTopRightRadius: "0.25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    POPULAR
                  </div>
                </div>
                <div
                  style={{
                    padding: "0.625rem",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    Standard
                  </div>
                  <div
                    style={{
                      color: "var(--BOA-Green, #66cb23)",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    $399 per month
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      wordWrap: "break-word",
                    }}
                  >
                    Additional Stock Locations
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      textDecoration: "line-through",
                      wordWrap: "break-word",
                    }}
                  >
                    $399 p/month
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      wordWrap: "break-word",
                    }}
                  >
                    $199 p/month
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "22.5%",
                  height: "13.625rem",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.625rem",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    width: "22.5%",
                    height: "2.25rem",
                    position: "relative",
                  }}
                />
                <div
                  style={{
                    height: "10.75rem",
                    padding: "0.625rem",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    Premium
                  </div>
                  <div
                    style={{
                      color: "var(--BOA-Green, #66cb23)",
                      fontSize: "1.5rem",
                      fontFamily: "Calibre",
                      fontWeight: 700,
                      wordWrap: "break-word",
                    }}
                  >
                    $599 per month
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      wordWrap: "break-word",
                    }}
                  >
                    Additional Stock Locations
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      textDecoration: "line-through",
                      wordWrap: "break-word",
                    }}
                  >
                    $599 p/month
                  </div>
                  <div
                    style={{
                      color: "var(--Black, black)",
                      fontSize: "0.938rem",
                      fontFamily: "Calibre",
                      fontWeight: 300,
                      wordWrap: "break-word",
                    }}
                  >
                    $299 p/month
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "inline-flex",
              }}
            >
              <div
                style={{
                  flex: "1 1 0",
                  background: "white",
                  overflow: "hidden",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Unlimited users
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Real people, real support
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Cart
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Smart Product Catalogue
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Job Management
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Automatic Cart Replenishment
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Invoicing (Xero Integration)
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Customer Management
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Asset Management
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    borderLeft: "0.063rem #c1c1c1 solid",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Advanced Inventory Management
                  </div>
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    padding: "0.625rem",
                    background: "white",
                    border: "0.063rem #c1c1c1 solid",
                    outlineOffset: "-0.063rem",
                    flexDirection: "column",
                    justifyContent: "baseline",
                    alignItems: "flex-start",
                    gap: "0.625rem",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "1rem",
                      fontFamily: "Calibre",
                      fontWeight: 400,
                      wordWrap: "break-word",
                    }}
                  >
                    Quote Management
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "22.5%",
                  background: "white",
                  overflow: "hidden",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderBottom: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
              </div>
              <div
                style={{
                  width: "22.5%",
                  background: "white",
                  overflow: "hidden",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderLeft: "0.25rem #66cb23 solid",
                    borderRight: "0.25rem #66cb23 solid",
                    borderBottom: "0.25rem #66cb23 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                />
              </div>
              <div
                style={{
                  width: "22.5%",
                  background: "white",
                  overflow: "hidden",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "inline-flex",
                }}
              >
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    borderTop: "0.063rem #c1c1c1 solid",
                    borderRight: "0.063rem #c1c1c1 solid",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
                <div
                  style={{
                    alignSelf: "stretch",
                    height:
                      getDeviceType(width) === "Mobile" ? "3.5rem" : "2.5rem",
                    paddingTop: "0.625rem",
                    paddingBottom: "0.625rem",
                    background: "white",
                    border: "0.063rem #c1c1c1 solid",
                    borderLeft: "none",
                    outlineOffset: "-0.063rem",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.625rem",
                    display: "inline-flex",
                  }}
                >
                  <div
                    style={{
                      width: "0.938rem",
                      height: "0.938rem",
                      background: "#66cb23",
                      borderRadius: "624.938rem",
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                color: "black",
                fontSize: "2rem",
                fontFamily: "Calibre",
                fontWeight: 400,
                wordWrap: "break-word",
                paddingTop: "3rem",
              }}
            >
              Need Custom Solutions?
            </div>
          </div>
          <div
            style={{
              width: "80%",
              height: "100%",
              paddingLeft: getDeviceType(width) === "Mobile" ? 10 : "10rem",
              paddingBottom: "2.188rem",
              background: "white",
              overflow: "hidden",
              flexDirection: "column",
              justifyContent: "flex-start",
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: "1.25rem",
                fontFamily: "Calibre",
                fontWeight: 400,
                wordWrap: "break-word",
                paddingTop: "1rem",
              }}
            >
              Our Enterprise offering provides tailored integrations and
              compliance tools. Contact us for a custom quote.
            </div>
            <ul
              style={{
                justifySelf: "flex-start",
                paddingRight:
                  getDeviceType(width) === "Mobile" ? 10 : "6.25rem",
              }}
            >
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                API Integration Add-ons
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom API Development: Build tailor-made APIs for clients to
                  connect your app with their internal systems.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Webhook Support: Allow real-time data synchronization between
                  your app and external platforms.
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Third-Party Accounting System Integration
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Xero, QuickBooks, and MYOB Integration: Automate financial
                  data syncing with popular accounting software.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom ERP Integration: Connect to enterprise-level ERP
                  systems (SAP, NetSuite, Odoo, etc.).
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Reporting &amp; Business Intelligence Add-ons
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom Dashboards &amp; KPI Tracking: Allow clients to create
                  tailored reports and dashboards.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Export to CSV, PDF, and Excel: Enable flexible data exports.
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Premium Support &amp; SLA
              </li>
              <ul style={{ marginTop: 0, paddingLeft: "2rem" }}>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  24/7 Dedicated Support.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Priority Issue Resolution: Offer faster response and
                  resolution times.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom Implementation Support.
                </li>
              </ul>
            </ul>
          </div>
        </div>
      ) : (
        <div className="mobile">
          <div
            style={{
              width: "100%",
              height: "100%",
              paddingLeft: "1rem",
              paddingRight: "1rem",
              paddingTop: "2.188rem",
              background: "white",
              overflow: "hidden",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: "3rem",
                fontFamily: "Calibre",
                fontWeight: 700,
                wordWrap: "break-word",
                paddingBottom: "1.5rem",
              }}
            >
              BOAhub PRICING
            </div>
            <div style={{ width: "100%" }}>
              <details
                open=""
                style={{
                  background: "#fff",
                  border: "1px solid #DDDDDD",
                  borderRadius: 8,
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  marginBottom: "1rem",
                  overflow: "hidden",
                }}
              >
                <summary
                  className="pricingSectionMobileLarge"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    fontFamily: "Calibre",
                    background: "#F8F8F8",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Ecommerce
                  <p
                    style={{
                      color: "#66CB23",
                      margin: 0,
                      fontSize: "1.75rem",
                      fontWeight: "bold",
                    }}
                  >
                    $150 per month
                  </p>
                </summary>
                <summary
                  className="pricingSectionMobileSmall"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontFamily: "Calibre",
                    background: "#F8F8F8",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Ecommerce
                  <p
                    style={{
                      color: "#66CB23",
                      margin: 0,
                      fontSize: "1.75rem",
                      fontWeight: "bold",
                    }}
                  >
                    $150 per month
                  </p>
                </summary>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: "1rem 1.5rem",
                    borderTop: "1px solid #DDDDDD",
                    fontFamily: "Calibre",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Unlimited users
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Real people, real support
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>Cart</p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Smart Product Catalogue
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                </div>
              </details>
              <details
                open=""
                style={{
                  background: "#fff",
                  border: "1px solid #DDDDDD",
                  borderRadius: 8,
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  marginBottom: "1rem",
                  overflow: "hidden",
                }}
              >
                <summary
                  className="pricingSectionMobileLarge"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    fontFamily: "Calibre",
                    background: "#66CB23",
                    color: "#FFFFFF",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Standard
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p
                      style={{
                        color: "#FFFFFF",
                        margin: 0,
                        fontSize: "1.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      $399 per month
                    </p>
                  </div>
                </summary>
                <summary
                  className="pricingSectionMobileSmall"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontFamily: "Calibre",
                    background: "#66CB23",
                    color: "#FFFFFF",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Standard
                  <p
                    style={{
                      color: "#FFFFFF",
                      margin: 0,
                      fontSize: "1.75rem",
                      fontWeight: "bold",
                    }}
                  >
                    $399 per month
                  </p>
                </summary>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: "1rem 1.5rem",
                    fontFamily: "Calibre",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                      borderBottom: "1px solid rgb(211, 211, 211)",
                      paddingBottom: "0.25rem",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Additional Stock Locations
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      $199 p/month
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                      paddingTop: "1rem",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Unlimited users
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Real people, real support
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>Cart</p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Smart Product Catalogue
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Job Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Automatic Cart Replenishment
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Invoicing (Xero Integration)
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Customer Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Asset Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                </div>
              </details>
              <details
                open=""
                style={{
                  background: "#fff",
                  border: "1px solid #DDDDDD",
                  borderRadius: 8,
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  marginBottom: "1rem",
                  overflow: "hidden",
                }}
              >
                <summary
                  className="pricingSectionMobileLarge"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    fontFamily: "Calibre",
                    background: "#F8F8F8",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Premium
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p
                      style={{
                        color: "#66CB23",
                        margin: 0,
                        fontSize: "1.75rem",
                      }}
                    >
                      $599 per month
                    </p>
                  </div>
                </summary>
                <summary
                  className="pricingSectionMobileSmall"
                  style={{
                    pointerEvents: "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontFamily: "Calibre",
                    background: "#F8F8F8",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    listStyleType: "none",
                    outline: "none",
                  }}
                >
                  Premium
                  <p
                    style={{ color: "#66CB23", margin: 0, fontSize: "1.75rem" }}
                  >
                    $599 per month
                  </p>
                </summary>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: "1rem 1.5rem",
                    fontFamily: "Calibre",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                      borderBottom: "1px solid rgb(211, 211, 211)",
                      paddingBottom: "0.25rem",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Additional Stock Locations
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      $299 p/month
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                      paddingTop: "1rem",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Unlimited users
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Real people, real support
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>Cart</p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Smart Product Catalogue
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Job Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Automatic Cart Replenishment
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Invoicing (Xero Integration)
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Customer Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Asset Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Advanced Inventory Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "space-between",
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "baseline",
                    }}
                  >
                    <p style={{ margin: 0, fontSize: "1.25rem" }}>
                      Quote Management
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "1.25rem",
                        color: "#66CB23",
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </p>
                  </div>
                </div>
              </details>
            </div>
            <div
              style={{
                color: "black",
                fontSize: "2rem",
                fontFamily: "Calibre",
                fontWeight: 400,
                wordWrap: "break-word",
                paddingTop: "3rem",
              }}
            >
              Need Custom Solutions?
            </div>
            <div
              style={{
                color: "black",
                fontSize: "1.25rem",
                fontFamily: "Calibre",
                fontWeight: 400,
                wordWrap: "break-word",
                paddingTop: "1rem",
              }}
            >
              Our Enterprise offering provides tailored integrations and
              compliance tools. Contact us for a custom quote.
            </div>
          </div>
          <div
            style={{
              height: "100%",
              paddingBottom: "2.188rem",
              background: "white",
              overflow: "hidden",
              flexDirection: "column",
              justifyContent: "flex-start",
              display: "inline-flex",
            }}
          >
            <ul style={{ justifySelf: "flex-start" }}>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                API Integration Add-ons
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom API Development: Build tailor-made APIs for clients to
                  connect your app with their internal systems.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Webhook Support: Allow real-time data synchronization between
                  your app and external platforms.
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Third-Party Accounting System Integration
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Xero, QuickBooks, and MYOB Integration: Automate financial
                  data syncing with popular accounting software.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom ERP Integration: Connect to enterprise-level ERP
                  systems (SAP, NetSuite, Odoo, etc.).
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Reporting &amp; Business Intelligence Add-ons
              </li>
              <ul
                style={{
                  paddingBottom: "1rem",
                  marginTop: 0,
                  paddingLeft: "2rem",
                }}
              >
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom Dashboards &amp; KPI Tracking: Allow clients to create
                  tailored reports and dashboards.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Export to CSV, PDF, and Excel: Enable flexible data exports.
                </li>
              </ul>
              <li
                style={{ fontSize: "1rem", textAlign: "left", fontWeight: 700 }}
              >
                Premium Support &amp; SLA
              </li>
              <ul style={{ marginTop: 0, paddingLeft: "2rem" }}>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  24/7 Dedicated Support.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Priority Issue Resolution: Offer faster response and
                  resolution times.
                </li>
                <li
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    fontFamily: "Calibre",
                    fontWeight: 400,
                  }}
                >
                  Custom Implementation Support.
                </li>
              </ul>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default PricingSection;
